import { render, staticRenderFns } from "./DiseasesAdd.vue?vue&type=template&id=e41ec2b0&scoped=true"
import script from "./DiseasesAdd.vue?vue&type=script&lang=ts"
export * from "./DiseasesAdd.vue?vue&type=script&lang=ts"
import style0 from "./DiseasesAdd.vue?vue&type=style&index=0&id=e41ec2b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e41ec2b0",
  null
  
)

export default component.exports